import { FC } from 'react';
import { TwoColumnWithBookingSummary } from 'components/Layout';
import useScrollTopOnMount from 'hooks/useScrollTopOnMount';
import RequestReviewInfo from './RequestReviewInfo';
import RequestAlert from './RequestAlert';
import RequestDetails from '../RequestDetails';
import ButtonGroup from 'components/ButtonGroup';
import { useChangeDatesRequestFlow } from '../ChangeDatesRequestFlowProvider';

const ReviewRequest: FC = () => {
  const { values, backToForm, createDateAmendmentRequest, loading } = useChangeDatesRequestFlow();
  const { checkIn, checkOut, phoneNumber, email } = values;

  useScrollTopOnMount();

  return (
    <TwoColumnWithBookingSummary heading="Review your date change request">
      <RequestReviewInfo />
      <RequestDetails mt={8} checkIn={checkIn} checkOut={checkOut} phoneNumber={phoneNumber} email={email} />
      <RequestAlert mt={7} mb={8} />
      <ButtonGroup
        mt={5}
        desktopBackLabel="Back"
        mobileBackLabel="Back"
        withBackIcon
        onClickBack={backToForm}
        continueLabel="Submit Request"
        onClickContinue={() => createDateAmendmentRequest(values)}
        continueButtonProps={{ loading, disabled: loading }}
        CustomContinueButton={null}
      />
    </TwoColumnWithBookingSummary>
  );
};

export default ReviewRequest;
